/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useTranslation } from 'react-i18next';

import ROUTES from 'constants/routes';
import { RESULT_STATUS } from 'constants/challenges';
import { CHALLENGE_PHASE } from 'constants/challenges';
import { ChallengeDatesType, IChallengesPartial } from 'interfaces';
import { getFormatedDates } from 'core/utils/date.helpers';
import { getChallengePhase } from 'core/utils/challenges.helpers';
import { CustomButton, CustomButtonType } from '../';
import * as S from './styles';

interface IChallengeDeclareButton {
  challenge: IChallengesPartial;
  title?: string;
  buttonSize?: CustomButtonType['size'];
}

export default function ChallengeDeclareButton({
  challenge,
  title,
  buttonSize,
}: IChallengeDeclareButton) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const dates: ChallengeDatesType = getFormatedDates(
    {
      challenge: {
        start: challenge.startDate,
        end: challenge.endDate,
      },
    },
    { day: 'numeric', month: 'short', year: 'numeric' },
    language,
  );
  const currentPhase = getChallengePhase(dates);

  const isChallengeInProgress =
    currentPhase === CHALLENGE_PHASE.DURING_CHALLENGE;
  const hasNoDeclarations = !challenge.declarations?.length;
  const areAllDeclarationsRefused = challenge.declarations?.every(
    (declaration) => declaration.status === RESULT_STATUS.REFUSED,
  );
  const canDeclare =
    isChallengeInProgress &&
    (challenge.isDeclarationMultiple ||
      hasNoDeclarations ||
      areAllDeclarationsRefused);

  const declareButton = (
    <CustomButton
      label={t('challenges.detail.declare.declareButton')}
      color="secondary"
      isDisabled={!canDeclare}
      href={`${ROUTES.BASENAME}${ROUTES.CHALLENGE}/${challenge.id}${ROUTES.DECLARE}`}
      size={buttonSize}
    />
  );

  return title ? (
    <S.Container>
      <S.Title variant="h4">{title}</S.Title>
      {declareButton}
    </S.Container>
  ) : (
    declareButton
  );
}
